import { useState } from 'react';

import useDashboardStats from '../dashboard/useDashboardStats';
import useDriverTypeDistribution from '../dashboard/useDriverTypeDistribution';
import useIncidentReport from '../dashboard/useIncidentReport';
import useVehicleStatus from '../dashboard/useVehicleStatus';
import useVehicleCategory from '../driver-setup/useVehicleCategory';
import useLookupConfig from '../lookup/useLookupConfig';
import useBusinessInfo from '../settings/useBusinessInfo';
import useGetSettings from '../settings/useGetSettings';
import useGetLookupCount from './useGetLookupCount';
import useKycStatus from './useKycStatus';

const useDashboardLoading = () => {
  const [loading, setLoading] = useState(false);
  const { businessInfo } = useBusinessInfo();
  const { LookupConfig } = useLookupConfig();
  const { kycStatus } = useKycStatus();
  const { getLookupCount } = useGetLookupCount();
  const { getVehicleCategory } = useVehicleCategory();
  const { getDashboardStats } = useDashboardStats();
  const { getIncidentReportData } = useIncidentReport();
  const { getVehicleStatus } = useVehicleStatus();
  const { getDriverTypeDistribution } = useDriverTypeDistribution();
  const { getSettings } = useGetSettings();
  const getDashboardLoadingData = async () => {
    setLoading(true);

    Promise.all([
      businessInfo(),
      getLookupCount(),
      // getExistingApiKeys(),
      kycStatus(),
      LookupConfig(),
      getVehicleCategory(),
      getDashboardStats(),
      getVehicleStatus(),
      getDriverTypeDistribution(),
      getSettings(),
      getIncidentReportData(),
    ])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return { getDashboardLoadingData, loading };
};

export default useDashboardLoading;
